
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import ApiService from '../../../services/ApiService';
import React, { useEffect, useState } from 'react';
import { MobCard } from '../../../mobile/components/MobCard';
import { Form, Select } from 'antd';
import { isMobile } from 'react-device-detect';
import { MOBCOLORS } from '../../../configs/AppConfig';

export const CHLIHOUTS=[
	{type:"CHABBAT",defaultTags:[]},
	{type:"CACHEROUT",defaultTags:[]},
	{type:"TAHARAT",defaultTags:[]},
	{type:"ECOLE",defaultTags:[]},
]

export function formatTextChlihout(type)
{
	switch (type)
	{
		case "CHABBAT":
			return t`Chabbat`
		case "CACHEROUT":
			return t`Cacherout`
		case "TAHARAT":
			return t`Taharat Hamichpaha`
		case "ECOLE":
			return t`École juive`
	}

	return type
}



export async function getChlihoutTags()
{
	let defaultTags=[...CHLIHOUTS.map(i=>({type:i.type,tags:i.defaultTags}))]

	const res=await ApiService.get("/contact/chlihout/tags")
	console.log(res)

	if(res.success){
		for(let c of res.items){
			const index=defaultTags.findIndex(i=>i.type===c.type)
			if(index>-1){
				if(Array.isArray(c.tags)){
					for(let t of c.tags){
						if(!defaultTags[index].tags.includes(t)){
							defaultTags[index].tags.push(t)
						}
					}
				}
			}
		}
	}

	//console.log("getChlihoutTags",defaultTags)

	return defaultTags
}

export function getChlihoutsItems(contact)
{
	let items=[...CHLIHOUTS.map(i=>({type:i.type,value:0,tags:[]}))]

	if(Array.isArray(contact.chlihouts)){
		for(let c of contact.chlihouts){
			const index=items.findIndex(i=>i.type===c.type)
			if(index>-1){
				items[index].tags=c.tags
				items[index].value=c.value
			}
		}
	}

	return items
}

export function ChlihoutBadge({ value })
{
	let color=MOBCOLORS.gray.color

	switch (value){
		case 1:
			color=MOBCOLORS.red.color
			break;
		case 3:
			color=MOBCOLORS.orange.color
			break;
		case 5:
			color=MOBCOLORS.amber.color
			break;
		case 7:
			color=MOBCOLORS.cyan.color
			break;
		case 10:
			color=MOBCOLORS.green.color
			break;
	}

	return(
		<div style={{display:"inline-block",width:10,height:10,marginRight:10,borderRadius:"100%",backgroundColor:color}}/>
	)
}


export default function ChlihoutForm({selected})
{
	const [chlihouts, setChlihouts] = useState(getChlihoutsItems(selected));
	const [tagsGroupes, setTagsGroupes] = useState([]);

	useEffect(()=>{
		getChlihoutTags().then((res)=>setTagsGroupes(res))
	},[selected.id])

	useEffect(()=>{
		if(JSON.stringify(chlihouts)!==JSON.stringify(getChlihoutsItems(selected))){
			console.log("SYNC TO BACK")
			ApiService.post("/contact/chlihout/"+selected.id,{chlihouts:chlihouts})
		}
	},[chlihouts])

	useEffect(() => {
		return()=>{
			console.log("SYNC TO BACK")
			ApiService.post("/contact/chlihout/"+selected.id,{chlihouts:chlihouts})
			selected.__refreshData()
		}
	}, []);

	const setChlihoutsItems=(item)=>{
		setChlihouts(_chlihouts=>_chlihouts.map(c=>c.type===item.type?item:c))
	}

	console.log("chlihouts",chlihouts)

	return(
		<>

			<div style={{display:"flex", flexDirection:"column",gap:20}}>
				{chlihouts.map((chlihout)=>
				{
					const tags=tagsGroupes.find(i=>i.type===chlihout.type)?.tags || []

					return(
						<MobCard>
							<div style={{display:"flex",flexDirection:"column",paddingTop:10,gap:isMobile?25:10}}>

								<div style={{display:"flex",flexDirection:isMobile?"column":"row",alignItems:'center',justifyContent:"space-between",gap:10}}>
									<h2 style={{
										color: "#000",
										fontSize: 20,
										marginBottom: 5,
										fontWeight:"bold"
									}}>{formatTextChlihout(chlihout.type)} :</h2>

									<Select style={{width:isMobile?"100%":300}} value={chlihout.value} onChange={(v)=>{
										chlihout.value=v
										setChlihoutsItems(chlihout)
									}}>
										<Select.Option value={0}><ChlihoutBadge value={0}/> <Trans>Inconnu</Trans></Select.Option>
										<Select.Option value={10}><ChlihoutBadge value={10}/> <Trans>Oui a 100%</Trans></Select.Option>
										<Select.Option value={7}><ChlihoutBadge value={7}/> <Trans>Peu encore s'ameliorer</Trans></Select.Option>
										<Select.Option value={5}><ChlihoutBadge value={5}/> <Trans>Encouragant</Trans></Select.Option>
										<Select.Option value={3}><ChlihoutBadge value={3}/> <Trans>Commence un peu</Trans></Select.Option>
										<Select.Option value={1}><ChlihoutBadge value={1}/> <Trans>Non a 100%</Trans></Select.Option>
									</Select>
								</div>

								{chlihout.value>0 && chlihout.value<10 &&(
									<Form.Item label={t`Les choses à améliorer`} layout={isMobile?"vertical":"horizontal"}>
										<Select placeholder={t`Lister les choses à améliorer`} mode={"tags"} style={{width:"100%"}} value={chlihout.tags} onChange={(v)=>{
											chlihout.tags=v
											setChlihoutsItems(chlihout)
										}}>
											{tags.map(t=>{
												return(
													<Select.Option value={t}>{t}</Select.Option>
												)
											})}
										</Select>
									</Form.Item>
								)}

							</div>
						</MobCard>
					)
				})}
			</div>
		</>
	)
}